import React, { useEffect, useState } from "react";
import { animate } from "framer-motion";

export default function GoldCounter({ value = 0, className = "", ...props }) {
  const [display, setDisplay] = useState(value);
  useEffect(() => {
    const controls = animate(display, value, {
      duration: 0.9,
      ease: "easeOut",
      onUpdate: (v) => setDisplay(Math.round(v)),
    });
    return () => controls.stop();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);
  return (
    <span className={`font-mono-ff tabular-nums ${className}`} {...props}>
      {display.toLocaleString()}
    </span>
  );
}
